import { render, staticRenderFns } from "./ModifyUserLoan.vue?vue&type=template&id=54ddd180"
import script from "./ModifyUserLoan.vue?vue&type=script&lang=js"
export * from "./ModifyUserLoan.vue?vue&type=script&lang=js"
import style0 from "./ModifyUserLoan.vue?vue&type=style&index=0&id=54ddd180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports